import React from 'react';
import { Outlet, Route } from 'react-router-dom';
import { AgendaSubscriptions, AgendaItemSubscriptions } from 'components/WebsocketSubscriptions';
import { lazyWithReload } from '@/utils';
import AgendaFilterScope from './routes/Agenda/AgendaFilterScope';

const Agenda = lazyWithReload(() => import('./routes/Agenda'));
const AgendaItemDetail = lazyWithReload(() => import('./routes/Agenda/AgendaItemDetail'));

// layout route: remounting these would reset filters the user set before opening an item.
// keyed on the event so a change of :eventID still rebinds the socket -- the layout element
// outlives the child routes, so nothing else would resubscribe to the new event's room.
const agendaRoutes = props => (
	<Route
		path={'agenda'}
		element={
			<AgendaFilterScope>
				<AgendaSubscriptions key={props.event?.id}>
					<Outlet />
				</AgendaSubscriptions>
			</AgendaFilterScope>
		}
	>
		<Route index element={<Agenda {...props} />} />
		<Route path={'create'} element={<AgendaItemDetail {...props} />} />
		<Route
			path={':id'}
			element={
				<AgendaItemSubscriptions>
					<AgendaItemDetail {...props} />
				</AgendaItemSubscriptions>
			}
		/>
	</Route>
);

export default agendaRoutes;
